import { Component, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { SessionModalService } from '../service/session-modal.service';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-session-expired',
  templateUrl: './sesion-expired-modal.component.html',
  styleUrls: ['./sesion-expired-modal.component.scss']
})
export class SessionExpiredComponent implements OnDestroy {
  visible$: Observable<boolean>;
  message$: Observable<string | null>;
  fatal$: Observable<boolean>;

  private fatalSub?: Subscription;
  private lastFatal: boolean = false;

  constructor(
    private sessionModal: SessionModalService,
    private router: Router,
    private auth: AuthService
  ) {
    this.visible$ = this.sessionModal.visible$;
    this.message$ = this.sessionModal.message$;
    this.fatal$ = this.sessionModal.fatal$;

    // Mantenemos un flag local para uso en onAccept() sin necesidad de combinar streams
    this.fatalSub = this.fatal$.subscribe(f => this.lastFatal = !!f);
  }

  onAccept() {
    // comportamiento distinto según tipo de modal
    if (this.lastFatal) {
      // limpieza + redirect cuando el modal es fatal
      this.auth.logout(true);
      // sessionModal.hide() no necesita redirect porque logout ya hace navegación
      this.sessionModal.hide();
      // router navigation opcional si tu logout no redirige inmediatamente
      // this.router.navigate(['/']);
    } else {
      // solo cerrar modal, preservar sesión
      this.sessionModal.hide(false);
    }
  }

  ngOnDestroy() {
    this.fatalSub?.unsubscribe();
  }
}
